import React from 'react';
import { useHistory } from 'react-router-dom';

import { LabelEnum, RouteEnum } from 'app/shared/enums';
import { useStyles } from './ErrorModal.styles';
import { ErrorModalProps } from './ErrorModal.interfaces';
import { MessageTypeEnum } from 'app/shared/enums';
import { Alert } from 'app/components/Alert';
import { CompactModal } from 'app/components/CompactModal';
import { NewButton } from 'app/components/NewButton';

export default function ErrorModal({
  action,
  error,
  onClose,
  buttonLabel = LabelEnum.GoToMubi,
}: ErrorModalProps) {
  const classes = useStyles();

  const history = useHistory();

  const handleClick = () => {
    if (action) {
      action();
    } else {
      history.push(RouteEnum.HOME);
    }
  };

  return (
    <CompactModal className={classes.modal} onClose={onClose}>
      <Alert
        title={error.title}
        text={error.message}
        type={MessageTypeEnum.Danger}
        className={classes.alert}
        dataCy="error-modal-mubi-installments"
      />
      <NewButton
        className={classes.button}
        onClick={handleClick}
        title={buttonLabel}
        variant={'contained'}
        color={'primary'}
        fullWidth
      />
    </CompactModal>
  );
}
